import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
const HOC = ({ children }) => {
  const location = useLocation();
  const navigate=useNavigate()
//   const [toggler,setToggler]=useState()
//   const auth=async()=>{
//     try{
//       const resp=await axios.post('http://localhost:5000',{cookieData:document.cookie.split('; ').filter((item=>item.split('=')[0]==='jwtoken'))[0].split('=')[1]})
//       const info=await resp.json()
      
//     }catch(error){
//       if(error.response.status===401){
//         if(location.pathname==='/signup'){
//           navigate('/signup')
//         }else{
//           navigate('/signin')
//         }
//       }
//     }
   
// }
//    useEffect(() => {
    
//     setTimeout(() => {
//      if(!(location.pathname==='/signup'&&location.pathname==='/signin')){
//        setToggler(!toggler)
//       }
//     }, 0);
//    }, [location.pathname]);
//    useEffect(()=>{auth()},toggler)
   
  return <div>{children}</div>;
};

export default HOC;
